import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Radio: ComponentStyleConfig = {
  baseStyle: {
    label: {
      margin: '0',
    },
    control: {
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      borderColor: 'neutral.600',
      marginRight: '12px',
      _checked: {
        background: 'white.500',
        borderColor: 'neutral.600',
        color: 'neutral.600',
        _before: {
          width: '12px',
          height: '12px',
        },
        _hover: {
          background: 'white.500',
          borderColor: 'neutral.600',
        },
      },
    },
  },
};
